/**
 * Returns specified component or null
 *
 * @param address {}
 * @param component
 */

export const getAddressComponent = (address: $TSFixMe, component: $TSFixMe) => {
  const matchingComponents = address[0].address_components.filter(
    (c: $TSFixMe) => c.types[0] === component,
  );
  if (matchingComponents.length > 0) {
    return matchingComponents[0].short_name;
  }
  return null;
};
